import ConfigurationService from '../Service/ConfigurationService';
import { RequestConfig } from 'tree-wallet-client';
import { request } from '../Helper/Http';

export async function exitImpersonation(config?: RequestConfig) {
  let requestConfig = config;

  if (!requestConfig) {
    requestConfig = {
      httpConfig: {
        headers: {
          'X-Switch-User': '_exit',
        }
      }
    }
  }

  await request(ConfigurationService.urls().stopImpersonationUrl, requestConfig);
}